import { QueryHookOptions } from '@apollo/client';
import { useUserRoles } from '@anytag/auth';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useAllPicUsersQuery } from '@anytag/graphql';

export const useAllPicUserOptions = (options?: QueryHookOptions<Query>) => {
  const { isAdminStaffTalentAgencyPartner } = useUserRoles();
  const { data } = useAllPicUsersQuery({
    skip: !isAdminStaffTalentAgencyPartner,
    fetchPolicy: 'cache-and-network',
    ...options
  });

  return { allPicsUserOptions: getSelectOptions(data?.allPicUsers) };
};
